import type { AiRecommendation } from './ai-recommendation.type.ts';
export interface AiRecommendationExtension extends AiRecommendation {}
export class AiRecommendationExtension {
  // Computed properties
  get isCompleted() {
    return this.actionable;
  }

  get hasData() {
    return Boolean(this.responseJson && Object.keys(this.responseJson).length > 0);
  }
}

const Registration = {
  kind: 'object',
  name: 'ai-recommendation',
  features: AiRecommendationExtension,
};
export default Registration;
